import { render, staticRenderFns } from "./Estimators.vue?vue&type=template&id=27ed754a&"
import script from "./Estimators.vue?vue&type=script&lang=js&"
export * from "./Estimators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports